import { Primitive } from '../Primitive';
import { Type } from '../Type';
export class PointCloud3D extends Primitive {
    points; // shape: (n, 3); n * XYZ
    colors; // shape: (n, 4); n * RGBA
    constructor(points, colors) {
        super(Type.PointCloud3D);
        this.points = points;
        this.colors = colors;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiUG9pbnRDbG91ZDNELmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi90eXBlcy9nZW9tZXRyeV8zZC9Qb2ludENsb3VkM0QudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsRUFBRSxNQUFNLGNBQWMsQ0FBQTtBQUN4QyxPQUFPLEVBQUUsSUFBSSxFQUFFLE1BQU0sU0FBUyxDQUFBO0FBRTlCLE1BQU0sT0FBTyxZQUFhLFNBQVEsU0FBUztJQUNoQyxNQUFNLENBQWMsQ0FBQyx5QkFBeUI7SUFDOUMsTUFBTSxDQUFhLENBQUMsMEJBQTBCO0lBRXZELFlBQVksTUFBb0IsRUFBRSxNQUFtQjtRQUNuRCxLQUFLLENBQUMsSUFBSSxDQUFDLFlBQVksQ0FBQyxDQUFBO1FBQ3hCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBO1FBQ3BCLElBQUksQ0FBQyxNQUFNLEdBQUcsTUFBTSxDQUFBO0lBQ3RCLENBQUM7Q0FDRiJ9